import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { KycService } from 'src/app/core/services/kyc.service';

export interface AgentReviewConfirmationDialogData {
  kycCheckId: string;
  extractedData: {
    fullName?: string;
    cpf?: string;
    dateOfBirth?: string;
    nationality?: string;
    documentType?: string;
    documentNumber?: string;
    documentCountry?: string;
    validFrom?: string;
    validUntil?: string;
    verificationStatus?: string;
    verificationCode?: number;
  };
  notes?: any[];
}

export interface AgentReviewConfirmationDialogResult {
  confirmed: boolean;
  revalidated?: boolean;
  passed?: boolean | null;
  kycCheckId?: string;
  message?: string;
}

@Component({
  selector: 'app-agent-review-confirmation-modal',
  templateUrl: './agent-review-confirmation-modal.component.html',
  styleUrls: ['./agent-review-confirmation-modal.component.scss'],
})
export class AgentReviewConfirmationModalComponent implements OnInit {
  loading = false;
  confirming = false;
  error = '';

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: AgentReviewConfirmationDialogData,
    public dialogRef: MatDialogRef<AgentReviewConfirmationModalComponent, AgentReviewConfirmationDialogResult>,
    private kycService: KycService
  ) {}

  ngOnInit(): void {
    console.log('[AgentReviewModal] Initialized with data:', {
      kycCheckId: this.data.kycCheckId,
      hasExtractedData: !!this.data.extractedData,
      extractedData: this.data.extractedData
    });
  }

  /**
   * Confirma a revisão e chama revalidate
   */
  async confirmReview(): Promise<void> {
    if (this.confirming || !this.data.kycCheckId) {
      return;
    }

    this.confirming = true;
    this.error = '';

    try {
      console.log('[AgentReviewModal] Confirming review for KYC check:', this.data.kycCheckId);

      // Chama revalidate
      const revalidateResult = await this.kycService.revalidateKycCheck(this.data.kycCheckId);

      console.log('[AgentReviewModal] Revalidate result:', revalidateResult);

      // Fecha o modal com resultado
      this.dialogRef.close({
        confirmed: true,
        revalidated: true,
        passed: revalidateResult.data.passed,
        kycCheckId: this.data.kycCheckId,
        message: revalidateResult.message
      });

    } catch (error: any) {
      console.error('[AgentReviewModal] Error during revalidation:', error);
      this.error = error.message || 'Failed to confirm review. Please try again.';
      this.confirming = false;
    }
  }

  /**
   * Cancela e fecha o modal
   */
  cancel(): void {
    this.dialogRef.close({
      confirmed: false,
      revalidated: false
    });
  }
}
